// Convierte el Markdown de los proyectos en elementos con el estilo de la web.
import { Box, Heading, Text, Link, Image } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const components = {
  h2: (props) => <Heading as="h2" fontSize="2xl" fontWeight="500" color="ink" mt={12} mb={4} {...props} />,
  h3: (props) => <Heading as="h3" fontSize="lg" fontWeight="500" color="ink" mt={8} mb={3} {...props} />,
  p: (props) => <Text lineHeight={1.8} my={4} {...props} />,
  a: (props) => <Link color="accent" textDecoration="underline" textUnderlineOffset="3px" isExternal {...props} />,
  strong: (props) => <Box as="strong" fontWeight="600" color="ink" {...props} />,
  img: ({ src, alt }) => (
    <Box as="span" display="block" my={8}>
      <Image src={src} alt={alt} w="100%" borderRadius="lg" border="1px solid" borderColor="border" bg="white" />
      {alt && <Text as="span" display="block" fontSize="sm" color="inkDim" textAlign="center" mt={2}>{alt}</Text>}
    </Box>
  ),
  ul: (props) => <Box as="ul" pl={5} my={4} {...props} />,
  ol: (props) => <Box as="ol" pl={5} my={4} {...props} />,
  li: (props) => <Box as="li" my={2} lineHeight={1.75} sx={{ '&::marker': { color: 'accent' } }} {...props} />,
  pre: (props) => (
    <Box
      as="pre"
      p={4}
      my={6}
      overflowX="auto"
      borderRadius="lg"
      bg="panel"
      border="1px solid"
      borderColor="border"
      fontSize="sm"
      lineHeight={1.6}
      sx={{ code: { bg: 'transparent', p: 0 } }}
      {...props}
    />
  ),
  code: (props) => (
    <Box as="code" fontFamily="mono" fontSize="0.88em" px={1.5} py={0.5} borderRadius="md" bg="accentSoft" color="ink" {...props} />
  ),
  table: (props) => (
    <Box overflowX="auto" my={6}>
      <Box as="table" w="100%" fontSize="sm" sx={{ borderCollapse: 'collapse' }} {...props} />
    </Box>
  ),
  th: (props) => <Box as="th" textAlign="left" py={2} pr={4} borderBottom="2px solid" borderColor="border" color="ink" fontWeight="600" {...props} />,
  td: (props) => <Box as="td" py={2} pr={4} borderBottom="1px solid" borderColor="border" verticalAlign="top" {...props} />,
  blockquote: (props) => <Box borderLeft="3px solid" borderColor="accent" pl={4} my={6} color="inkDim" {...props} />,
};

export default function Markdown({ children }) {
  return (
    <Box color="inkDim">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </Box>
  );
}
